import { CommonService } from './../Services/common.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DatePipe } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { Subject } from "rxjs";
import { AccountService, cardDetail } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CardServiceService } from '../Services/card-service.service';
import { Base64 } from 'js-base64';
import { saveAs } from 'file-saver';
import { Location } from '@angular/common';
import * as moment from "moment";
import { TopupServiceService } from '../Services/topup-service.service';
import { CookieService } from '../Services/cookie';
import { ToastrService } from 'ngx-toastr';
import { RewardsService } from '../loyalty-points/rewardservice/rewards.service';
import { TranslateService } from "@ngx-translate/core";
import { SettingService } from '../Services/setting.service';
import { NgOtpInputComponent } from 'ng-otp-input';





// import { event } from 'jquery';
// import * as $ from 'jquery';



@Component({
  selector: "app-dashboard-credit-cards",
  templateUrl: "./dashboard-credit-cards.component.html",
  standalone: false,
  styleUrls: ["./dashboard-credit-cards.component.scss"],
})
export class DashboardCreditCardsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  ViewCardDetail: boolean = false;
  @ViewChild('otpInput') otpInput!: NgOtpInputComponent;
  @ViewChild('otpInputMobile') otpInputMobile!: NgOtpInputComponent; // For mobile OTP
  selectedMonth: string = "";
  Monthlist;
  disabledServices: boolean = false;
  FundNamelist;
  MonthYear: string = "";
  nameFromNickName: string;
  otp: string = "";
  OptTimerbtnShow: boolean = false;
  timeoutHandle;
  timerexpire;
  ReasonsList;
  LettersList;
  selectedTrasactions: string = "All Trasactions";
  Trasactionslist;
  UnGroupCardTransactionHistory;
  GroupCardTransactionHistory;
  AutoTempLimit: any;
  PaymentRequired: boolean = false;
  ReplaceCard: boolean = false;
  PaymentDetail;
  RequestPhysicalSendSMSOTP: boolean = false;
  Action: string;
  // selectedTransactionHistory
  transactionRefId: string = "";
  Eemail: any;
  MobNum: any;
  maskemail: any;
  internalId: string;
  Home: string;
  sinnadStatus: any;
  sinnadExistingCheck: string;
  cardInternalID: any;
  cardProductCode: any;
  showCardDetails: boolean = false;
  eVerifyOTP: string = "";
  maskedEmail: Promise<void>;
  Mverifyotp: string;
  maskMobileNO: Promise<void>;
  publicKEY: any;
  encdata: any;
  encdata2: any;
  privateKEY: any;
  isLoadingComplete: boolean;
  NumberView: string;
  cNumber: any;
  mobilNomasked: any;
  epDate: string;
  ServiceType: any;
  availableBalance: any;
  outstandingBalance: any;
  usedPercentage: number;

  carouselOptions: OwlOptions = {
    loop: false,
    nav: true,
    dots: true,
    items: 1,
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 }
    }
  };

  // selectedTransactionHistory
  constructor(
    private location: Location,
    private account: AccountService,
    public datepipe: DatePipe,
    public commonP: CommonService,
    public auth: AuthService,
    public _router: Router,
    public cardService: CardServiceService,
    public topupservice: TopupServiceService,
    private toastr: ToastrService, private reward: RewardsService,
    private translate: TranslateService,
    private setting: SettingService,
    private cookieService: CookieService
  ) {
    // this.toastr.success(
    //   "You have successfully activated your card.",
    //   "Your are now available to make transactions with your card."
    // );
    // this.toastr.success(
    //   "Card Nickname Added",
    //   "You have succesfully added nickname to your selected card"
    // );
  }
  LoyaltyCards;
  loyalityPoints: number = 0;

  cardDetail;
  serviceType: string;
  selectedCardIndex: number;
  /** Index whose details are currently loaded; guards redundant (translated) re-fires. */
  loadedCardIndex: number = null;
  /** Drives the inline skeleton on the transaction list while a card's transactions load. */
  transactionsLoading: boolean = false;
  /** Last-10 transactions already fetched this visit, keyed by card internalId. */
  transactionCache: { [internalId: string]: any } = {};
  /** Placeholder rows for the transaction skeleton. */
  skeletonRows = [1, 2, 3, 4];
  selectedCardDetail: cardDetail;
  showTransaction: boolean = false;
  enableViewCard: boolean = false;
  ViewStatementList;
  ViewGroupTransaction: boolean = false;
  Downloadstatement;
  SelectedtransactionDetail;
  totalslidervalues: string[] = [];
  selectedReasonId: string = "";
  RLServiceid: string = "";
  TotalAmount: number = 0;

  // slideConfig = {
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   vertical: false,
  //   arrows: true,
  //   dots: true,
  //   adaptiveHeight: false,
  //   infinite: false,
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         vertical: false,
  //       },
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         arrows: false,
  //       },
  //     },
  //   ],
  // };

  async ngOnInit(): Promise<void> {
    //

    this.serviceType = await this.cookieService.get("sTyp", true);
    console.log("serviceTypeData", this.serviceType);
    // blank the internal id

    this.cookieService.set("InternallID", "", true);
    // 
    let Id = await this.cookieService.get("InternalId", true);
    if (Id) {
      this.internalId = Id;

    }
    let H = await this.cookieService.get("Home", true);

    if (H) {
      this.Home = H;
    }
    await this.commonP.presentLoading();

    this.Trasactionslist = [
      {
        iconClass: "",
        displayValue: "Unbilled",
      },
      {
        iconClass: "",
        displayValue: "LAST 10 TRANSACTIONS",
      },
      {
        iconClass: "",
        displayValue: "HOLD",
      },
      {
        iconClass: "",
        displayValue: "CURRENT",
      },
      {
        iconClass: "",
        displayValue: "PREVIOUS",
      },
    ];
    this.Monthlist = [
      {
        iconClass: "",
        displayValue: "January",
      },
      {
        iconClass: "",
        displayValue: "Febuary",
      },
      {
        iconClass: "",
        displayValue: "March",
      },
      {
        iconClass: "",
        displayValue: "April",
      },
      {
        iconClass: "",
        displayValue: "May",
      },
      {
        iconClass: "",
        displayValue: "June",
      },
      {
        iconClass: "",
        displayValue: "July",
      },
      {
        iconClass: "",
        displayValue: "August",
      },
      {
        iconClass: "",
        displayValue: "September",
      },
      {
        iconClass: "",
        displayValue: "October",
      },
      {
        iconClass: "",
        displayValue: "November",
      },
      {
        iconClass: "",
        displayValue: "December",
      },
    ];
    //
    // if (this.account.getDashboardDetail?.cardDetails == undefined) {
    if (this.account.getDashboardDetail?.cardDetails.length != 0) {
      this.sinnadStatus = this.account.getDashboardDetail?.cardDetails[0]
      console.log("sinadStatus1", this.sinnadStatus);



      // yousuf here to un commet code
      this.auth.accessToken = await this.commonP.Get("token");
      // Promise.all([this.Verifytoken(), this.DashboardApi()]) 
      this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {

        if (data?.response?.code == 1) {
          this.MobNum = data.response.content.mobileNumber;
          this.Eemail = data.response.content.emailId;
          console.log(this.Eemail, this.MobNum, "hereusu2");
          this.DashboardApi()
        }
        else {
          await this.commonP.hideLoading();
          // this.commonP.ParseErrorAlert("", "", this._router, data);
        }

      });

      // this.DashboardApi();
    }
    else {
      //
      // this.commonP.hideLoading();
      this.commonP.presentLoading();
      let CardDetails = this.account.getDashboardDetail?.cardDetails;

      if (CardDetails.length != 0) {

        console.log("CardDetails3", CardDetails);
        this.cardDetail = CardDetails.filter((x) => x.displayFlag == "Y");
        for (let item of this.cardDetail) {
          //
          // let cal=(Number(item.availableCreditLimit - (- item.outstandingAmount))/100);
          let cal = item.outstandingAmount / 100;
          console.log("cal", cal);
          if (cal < 0) {
            this.totalslidervalues.push("0");
          } else {
            this.totalslidervalues.push(cal.toString());
          }
        }
        if (this.internalId != undefined && this.internalId != "" && this.Home == 'Home') {

          this.cardDetail.filter((x, index) => {

            if (x.internalId == this.internalId) {

              this.selectedCardDetail = x

              this.cardDetail.splice(index, 1);

              this.cardDetail.unshift(x);
              this.selectCard(0);

            }
          })
        }
        else {
          this.selectedCardDetail = this.cardDetail[0];
          this.loadedCardIndex = 0;
          let body = {
            internalId: this.selectedCardDetail?.internalId,
            numberOfTransactions: "10",
            transactionType: "Last",
          };

          // await this.commonP.presentLoading()
          if (this.selectedCardDetail?.freezed == "N" && this.selectedCardDetail?.stopped == "N") {
            //
            this.cardService
              .GetTransactionUngroup(body, this.auth.accessToken)
              .then((data: any) => {
                if (data?.response?.code == 1) {
                  //
                  let CardTransactionHistory =
                    data.response.content.cardTransactions;
                  this.UnGroupCardTransactionHistory = CardTransactionHistory;

                  this.selectedCardIndex = 0;
                  this.showTransaction = true;
                  this.commonP.hideLoading();

                  // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                  // this.selectedCardDetail=this.cardDetail[0];
                } else {
                  //
                  this.commonP.hideLoading();
                  this.commonP.ParseErrorAlert("", "", this._router, data);
                }
              });
          }
          if (this.selectedCardDetail?.freezed == "Y") {
            //

            this.cardService
              .GetTransactionUngroup(body, this.auth.accessToken)
              .then((data: any) => {
                if (data?.response?.code == 1) {
                  //
                  let CardTransactionHistory =
                    data.response.content.cardTransactions;
                  this.UnGroupCardTransactionHistory = CardTransactionHistory;
                  this.selectedCardIndex = 0;
                  this.showTransaction = true;
                  this.commonP.hideLoading();

                  // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                  // this.selectedCardDetail=this.cardDetail[0];
                } else {
                  //
                  this.commonP.hideLoading();
                  this.commonP.ParseErrorAlert("", "", this._router, data);
                }
              });
          }
          if (this.selectedCardDetail?.stopped == "Y") {
            //

            // this.commonP.hideLoading();
            // this.selectedCardIndex = 0;
            // this.showTransaction = false;
            this.cardService
              .GetTransactionUngroup(body, this.auth.accessToken)
              .then((data: any) => {
                if (data?.response?.code == 1) {
                  //
                  let CardTransactionHistory =
                    data.response.content.cardTransactions;
                  this.UnGroupCardTransactionHistory = CardTransactionHistory;
                  this.selectedCardIndex = 0;
                  this.showTransaction = true;
                  this.commonP.hideLoading();

                  // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                  // this.selectedCardDetail=this.cardDetail[0];
                } else {
                  this.commonP.hideLoading();
                  //
                  this.commonP.ParseErrorAlert("", "", this._router, data);
                }
              });
          }

        }
        // if (
        //   this.selectedCardDetail &&
        //   this.selectedCardDetail?.activationFlag == "N"
        // ) {
        //
        //   this.OptTimerbtnShow = true;
        //   this.startTime();
        //   this.auth
        //     .CardActivationSendOTP(this.auth.accessToken)
        //     .then((res: any) => {
        //
        //       if (res?.response?.code == 1) {
        //         this.otp = "";
        //         // this.showModal("close", '');
        //         this.showModal(14, "");
        //         this.commonP.hideLoading();

        //
        //       } else {
        //         this.commonP.hideLoading();
        //         this.commonP.ParseErrorAlert("Sorry", "Ok", this._router, res);
        //       }
        //     });
        // }


      }
      else {
        this.commonP.hideLoading();
        this.cardDetail = [];
      }
    }
  }

  /**
   * Resolves the card index from either an owl-carousel-o event payload
   * (SlidesOutputData: { startPosition, slides }) or a plain index passed by
   * internal callers such as selectCard(0).
   */
  private resolveCardIndex(e): number {
    if (typeof e === "number") {
      return e;
    }
    if (e && typeof e.startPosition === "number") {
      return e.startPosition;
    }
    return null;
  }

  selectCard(e) {

    const index = this.resolveCardIndex(e);
    const card = index != null ? this.cardDetail?.[index] : null;

    if (!card) {
      return;
    }

    // (translated) can fire more than once for a single swipe (drag + snap),
    // and once on carousel init for the card the page already loaded.
    // Only reload when the selected card actually changed.
    if (this.loadedCardIndex === index) {
      return;
    }
    this.loadedCardIndex = index;

    this.cookieService.set("InternallID", "", true);
    // No presentLoading() here: every card already came down with the dashboard
    // payload, so switching cards renders instantly. Only the transactions need
    // fetching, and those show an inline skeleton instead of blocking the page.

    // clear data
    this.showCardDetails = false
    this.eVerifyOTP = ""
    this.isLoadingComplete = false;
    this.NumberView = ""

    this.selectedCardDetail = card;
    this.sinnadExistingCheck = card.source
    console.log("sourcechange", this.sinnadExistingCheck);
    // internal id sinnad pinchange
    // outstanding line
    this.availableBalance = card.availableCreditLimit;
    this.outstandingBalance = card.outstandingAmount;
    const available = Number(this.availableBalance) || 0;
    const outstanding = Math.abs(Number(this.outstandingBalance)) || 0;

    // total limit (max value)
    const totalLimit = available + outstanding;

    // percentage calculate karo
    this.usedPercentage = totalLimit ? (outstanding / totalLimit) * 100 : 0;

    // agar value 100 se zyada ho jaye to clamp kar do
    if (this.usedPercentage > 100) {
      this.usedPercentage = 100;
    }

    // outstanding line
    this.cardInternalID = card?.internalId;
    console.log("cardInternalID2", this.cardInternalID);

    this.cookieService.set("InternallID", this.cardInternalID, true);

    //  product codes 
    this.cardProductCode = card?.productCode;
    console.log("cardProductCode2", this.cardProductCode);

    console.log("this.selectedCardDetail", this.selectedCardDetail);

    // Always refresh the last-10 list for the newly selected card.
    this.getCardTransactionUnGroup(card?.internalId);

    // The carousel lives in a different column than the transaction history, so
    // the user can swipe while the grouped/statement view is open. That view
    // renders GroupCardTransactionHistory, which getCardTransactionUnGroup does
    // not touch - re-run their selected filter against the new card so it does
    // not keep showing the previous card's transactions.
    if (this.ViewGroupTransaction) {
      this.onTrasactionsChange(this.selectedTrasactions, true);
    }

    if (card?.freezed == "N" && card?.stopped == "N") {
      this.selectedCardIndex = index;
      this.showTransaction = true;
    }
    if (card?.freezed == "Y") {
      this.selectedCardIndex = null;
      this.showTransaction = true;
    }
    if (card?.stopped == "Y") {
      this.selectedCardIndex = index;
      this.showTransaction = false;
      this.disabledServices = true;
    } else {
      this.disabledServices = false;
    }
  }

  GetLoanDashboad() {
    this.account.GetLoanDashboard(this.auth.accessToken).then((data: any) => {
      if (data?.response?.code == 1) {
        let CardDetails = data.response.content.cardDetails;
        this.cardDetail = CardDetails.filter((x) => x.displayFlag == "Y");
        //
        console.log("CardDetails1", CardDetails);
        for (let item of this.cardDetail) {
          //

          // let cal=(Number(item.availableCreditLimit - (- item.outstandingAmount))/100);

          let cal = item.outstandingAmount / 100;
          console.log("Cal", cal);
          //
          if (cal < 0) {
            this.totalslidervalues.push("0");
          } else {
            this.totalslidervalues.push(cal.toString());
          }
        }
        this.selectedCardDetail = this.cardDetail[0];
        this.loadedCardIndex = 0;
        // this.cardDetail=[];

        let body = {
          internalId: this.selectedCardDetail?.internalId,
          numberOfTransactions: "10",
          transactionType: "Last",
        };

        if (
          this.selectedCardDetail?.freezed == "N" &&
          this.selectedCardDetail?.stopped == "N"
        ) {
          this.cardService
            .GetTransactionUngroup(body, this.auth.accessToken)
            .then((data: any) => {
              if (data?.response?.code == 1) {
                this.commonP.hideLoading();
                //
                let CardTransactionHistory =
                  data.response.content.cardTransactions;
                this.UnGroupCardTransactionHistory = CardTransactionHistory;
                this.selectedCardIndex = 0;
                // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                // this.selectedCardDetail=this.cardDetail[0];
              } else {
                //

                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert("", "", this._router, data);
              }
            });
          this.showTransaction = true;
        }
        if (this.selectedCardDetail?.freezed == "Y") {
          //

          this.cardService
            .GetTransactionUngroup(body, this.auth.accessToken)
            .then((data: any) => {
              if (data?.response?.code == 1) {
                this.commonP.hideLoading();
                let CardTransactionHistory =
                  data.response.content.cardTransactions;
                this.UnGroupCardTransactionHistory = CardTransactionHistory;
                this.selectedCardIndex = null;
                // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                // this.selectedCardDetail=this.cardDetail[0];
              } else {
                //

                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert("", "", this._router, data);
              }
            });
          this.showTransaction = true;
        }
        if (this.selectedCardDetail?.stopped == "Y") {
          //

          this.commonP.hideLoading();
          this.selectedCardIndex = 0;
          this.showTransaction = false;
        }
      } else {
        //
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }
  getCardTransactionUnGroup(id) {

    // Already fetched this card during this visit - swipe back to it for free.
    if (id && this.transactionCache[id]) {
      this.transactionsLoading = false;
      this.UnGroupCardTransactionHistory = this.transactionCache[id];
      return;
    }

    // Inline skeleton rather than commonP.presentLoading(): only this list is
    // waiting on data, so there is no reason to block the rest of the page.
    this.transactionsLoading = true;
    let body = {
      internalId: id,
      numberOfTransactions: "10",
      transactionType: "Last",
    };
    this.cardService
      .GetTransactionUngroup(body, this.auth.accessToken)
      .then((data: any) => {
        this.transactionsLoading = false;
        if (data?.response?.code == 1) {
          let CardTransactionHistory = data.response.content.cardTransactions;
          this.UnGroupCardTransactionHistory = CardTransactionHistory;
          if (id) {
            this.transactionCache[id] = CardTransactionHistory;
          }
          console.log(
            "GetTransactionUngroup",
            this.UnGroupCardTransactionHistory
          );
        } else {
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      })
      .catch((err) => {
        this.transactionsLoading = false;
        throw err;
      });
  }
  getClass(index, card) {
    if (card.stopped == 'N' && card.freezed == 'N' && card.activationFlag != 'N') {
      return ""
      // this.toastr.success('You have successfully activate your card.', ' You are now available to make transaction with your card.');

    }
    else if (card.stopped == 'Y') {

      return 'card-stop'

    }
    else if (card.freezed == 'Y') {

      return 'freezed'


    }
    else if (card.activationFlag == 'N') {

      return 'deactive'

    }
    return '';
  }

  onMonthChange(event) {
    this.selectedMonth = event.displayValue;
    this.MonthYear = event.value;
  }

  onTrasactionsChange(event, useSkeleton = false) {

    this.selectedTrasactions = event.displayValue ? event.displayValue : event;
    console.log("selectedTrasactions", this.selectedTrasactions);

    // Changing the filter is a deliberate action and keeps the blocking loader.
    // Swiping to another card passes useSkeleton so only the list shows waiting.
    const startWait = () => {
      if (useSkeleton) {
        this.transactionsLoading = true;
      } else {
        this.commonP.presentLoading();
      }
    };
    const endWait = () => {
      if (useSkeleton) {
        this.transactionsLoading = false;
      } else {
        this.commonP.hideLoading();
      }
    };

    if (this.selectedTrasactions !== "LAST 10 TRANSACTIONS") {
      startWait();

      let body = {
        internalId: this.selectedCardDetail?.internalId,
        numberOfTransactions: 0,
        transactionType: this.selectedTrasactions == "Unbilled" ? "Current" : this.selectedTrasactions == "PREVIOUS" ? "Previous" : this.selectedTrasactions,
      };
      this.cardService
        .GetTransactiongroup(body, this.auth.accessToken)
        .then((data: any) => {
          if (data?.response?.code == 1) {
            endWait();
            // this.UnGroupCardTransactionHistory = [];
            let GroupCardTransactionHistory = data?.response?.content;
            this.GroupCardTransactionHistory = GroupCardTransactionHistory;
            console.log(
              "GetTransactiongroup",
              this.GroupCardTransactionHistory
            );
            // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
            // this.selectedCardDetail=this.cardDetail[0];
          } else {
            endWait();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    }
    else {
      startWait();
      let body = {
        internalId: this.selectedCardDetail?.internalId,
        numberOfTransactions: 10,
        transactionType: "Last",
      };
      this.cardService
        .GetTransactiongroup(body, this.auth.accessToken)
        .then((data: any) => {
          if (data?.response?.code == 1) {
            endWait();
            // this.UnGroupCardTransactionHistory = [];
            let GroupCardTransactionHistory = data?.response?.content;
            this.GroupCardTransactionHistory = GroupCardTransactionHistory;
            this.ViewGroupTransaction = true;
            console.log(
              "GetTransactiongroup",
              this.GroupCardTransactionHistory
            );

            // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
            // this.selectedCardDetail=this.cardDetail[0];
          } else {
            endWait();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    }
  }
  getMonthsDates(num) {
    // this.commonP.presentLoading();
    // this.cardService.GetCardDates({ InternalId: this.selectedCardDetail?.internalId }, this.auth.accessToken).then((data: any) => {
    //   if (data?.response?.code == 1) {
    //     this.commonP.hideLoading();
    //     let MonthsList = data.response.content;
    //     ('getMonthsDates', data.response.content);
    //     this.Monthlist = MonthsList.map(x => ({
    //       displayValue: x.displayValue,
    //       value: x.value
    //     }))
    //     this.showModal(num);
    //   } else {
    //
    //     this.commonP.hideLoading();
    //     this.commonP.ParseErrorAlert('', '', this._router, data);
    //   }
    // })
  }


  activateCard() {

    // if (
    //   this.selectedCardDetail &&
    //   this.selectedCardDetail?.activationFlag == "N"
    // ) {
    //
    this.OptTimerbtnShow = true;
    this.commonP.presentLoading()
    this.startTime();
    // this.auth.CardActivationSendOTP(this.auth.accessToken).then((res: any) => {
    //
    //   if (res?.response?.code == 1) {
    //     this.otp = "";
    //     // this.showModal("close", '');
    //     this.showModal(14, "");
    //     this.commonP.hideLoading();

    //
    //   }
    //   else {
    //     this.commonP.hideLoading();
    //     this.commonP.ParseErrorAlert(
    //       "Sorry",
    //       "Ok",
    //       this._router,
    //       res
    //     );
    //   }
    // });

    // }

    this.auth.CardActivationSendOTP(this.auth.accessToken).then((res: any) => {
      //
      if (res?.response?.code == 1) {
        this.otp = "";
        // this.showModal("close", '');
        this.showModal(14, "");
        this.commonP.hideLoading();

        //
      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert(
          "Sorry",
          "Ok",
          this._router,
          res
        );
      }
    });

  }

  GetFeildValues(type) {
    //
    this.commonP.presentLoading();
    this.auth
      .GetFieldValues(type, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          await this.commonP.hideLoading();
          if (type == "CR") {
            this.ReasonsList = data?.response?.content?.list?.CR;
            //
          }
          // if(type=='SRL'){
          //   this.ReasonsList=data?.response?.content?.list?.SRL;
          // }

          console.log("ReasonsList", this.ReasonsList);

          // this.ReasonsList=ReasonsList?.map(x=>({
          //  value:x.strCode,
          //  displayValue:x.labelEn

          // }))
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  showModal(num, data) {
    if (data == "close") {
      this.modalObservable.next(data);
    }
    this.modalObservable.next(num);
    this.otp = "";

    if (num == 7) {
      this.SelectedtransactionDetail = data;
    }
    if (num == 71) {
      this.SelectedtransactionDetail = data;
    }

    // if (num == 14 && this.selectedCardDetail.physicalOrVirtual != 'Physical' &&  this.Action != 'RequestPhysicalCard' ) {
    if (
      num == 18 &&
      this.selectedCardDetail.physicalOrVirtual != "Physical" &&
      this.Action != "RequestPhysicalCard"
    ) {
      //
      this.OptTimerbtnShow = true;
      this.startTime();
      // this.RDCEmailOTP();
    }
    else if (
      num == 18 &&
      this.selectedCardDetail.physicalOrVirtual == "Physical" &&
      this.Action != "RequestPhysicalCard"
    ) {
      //
      this.OptTimerbtnShow = true;
      this.startTime();
      this.SendOtp();
    }
  }

  // RDCEmailOTP() {
  ReplaceDigitalSendOTP() {
    //
    this.OptTimerbtnShow = true;
    this.startTime();
    this.commonP.presentLoading();
    //  this.auth.RDCEmailOTP({}, this.auth.accessToken).then((data: any) => {
    this.auth
      .ReplaceDigitalSendOTP({}, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          this.otp = "";
          this.showModal("close", "");
          this.showModal(14, "");
        } else {
          this.commonP.presentLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  SendOtp() {
    //
    this.OptTimerbtnShow = true;
    this.startTime();
    this.commonP.presentLoading();
    // this.auth.CRSendEmailOTP({}, this.auth.accessToken).then((data: any) => {
    this.auth
      .CardReplacementSendOTP({}, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {

          this.commonP.hideLoading();
          this.otp = "";
          this.showModal("close", "");
          this.showModal(14, '');

          let email = this.auth.detailuser?.emailId;

          // this.maskemail = this.commonP.maskEmail(email);
          // this._router.navigate(["/VerifyEmailOtp"], {
          //   queryParams: {maskemail: this.maskemail,Replace:'PhyReplace'},
          // });        
        }
        else {
          this.commonP.presentLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
  transactionHistory() {
    this._router.navigateByUrl("/CardTransactionHistory");
  }
  cardRequestSupplementary() {
    this._router.navigateByUrl("/CardRequestSupplementary");
  }
  cardRequestLetters() {


    this.cookieService.set("selectedCardDetail", JSON.stringify(this.selectedCardDetail), true);
    this._router.navigateByUrl("/CardRequestLetters");

  }

  // EnableViewCard(e) {

  //   this.enableViewCard = e.checked;

  //   if (this.enableViewCard == true) {

  //     this.showModal(18, "");
  //     //   this.ViewCardDetail = false;
  //     // } else {
  //     //   this.ViewCardDetail = true;
  //   }
  // }





  maskCardNumber() {
    // Logic to mask the card number
    // Implement this based on how the card number is being displayed or stored
    console.log('Card number masked');
  }
  UpdateCardStatus(status) {
    let body = {
      InternalId: this.selectedCardDetail?.internalId,
      Status: status,
      StopReasonCode: "",
    };
    this.commonP.presentLoading();
    this.cardService
      .UpdateCardStatus(body, this.auth.accessToken).then((data: any) => {

        if (data?.response?.code == 1) {
          if (data.response.content.status) {

            if (status == 'CCRP') {


              this.cookieService.set('flow', 'ManagePin', true);
              this._router.navigateByUrl('/VerifyEmailOtp')
            }
            this.account.GetLoanDashboard(this.auth.accessToken).then((data: any) => {
              if (data?.response?.code == 1) {
                let CardDetails = data.response.content.cardDetails;
                this.cardDetail = CardDetails.filter((x) => x.displayFlag == "Y");
                this.selectedCardDetail = this.cardDetail[0];
                this.loadedCardIndex = 0;
                // this.cardDetail=[];
                let body = {
                  internalId: this.selectedCardDetail?.internalId,
                  numberOfTransactions: "10",
                  transactionType: "Last",
                };
                if (this.selectedCardDetail?.freezed == "N") {
                  //

                  this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
                    if (data?.response?.code == 1) {
                      let CardTransactionHistory =
                        data.response.content.cardTransactions;
                      this.UnGroupCardTransactionHistory =
                        CardTransactionHistory;
                      this.selectedCardIndex = 0;
                      this.commonP.hideLoading();

                      // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                      // this.selectedCardDetail=this.cardDetail[0];
                    }
                    else {
                      this.commonP.hideLoading();
                      this.commonP.ParseErrorAlert(
                        "",
                        "",
                        this._router,
                        data
                      );
                    }
                  });
                  this.showTransaction = true;
                }
                else if (this.selectedCardDetail?.freezed == "Y") {
                  //
                  this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
                    if (data?.response?.code == 1) {
                      let CardTransactionHistory = data.response.content.cardTransactions;
                      this.UnGroupCardTransactionHistory = CardTransactionHistory;
                      this.selectedCardIndex = null;
                      this.commonP.hideLoading();

                      // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                      // this.selectedCardDetail=this.cardDetail[0];
                    } else {
                      this.commonP.hideLoading();
                      this.commonP.ParseErrorAlert(
                        "",
                        "",
                        this._router,
                        data
                      );
                    }
                  });
                  this.showTransaction = true;
                } else if (this.selectedCardDetail?.stopped == "Y") {
                  //
                  this.selectedCardIndex = 0;
                  this.showTransaction = false;
                }
              } else {
                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert("", "", this._router, data);
              }
            });
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
          // let CardTransactionHistory=data.response.content.cardTransactions;
          // this.CardTransactionHistory=CardTransactionHistory
          // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
          // this.selectedCardDetail=this.cardDetail[0];
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }


  ReIssueCardPinOTp() {
    this.commonP.presentLoading();
    this.auth.ReIssueCardPinOtp(this.auth.accessToken).then((res: any) => {
      if (res?.response?.code == 1) {
        this.commonP.hideLoading();

        this.cookieService.set("Screen", "Reissue", true);
        this._router.navigateByUrl("/EnterMobilePin");
      }
      else {
        this.commonP.hideLoading();

        this.cookieService.set("Screen", "Reissue", true);
        this._router.navigateByUrl("/ChangePin");
        this._router.navigateByUrl("/EnterMobilePin");

        // this.commonP.ParseErrorAlert("","OK",this._router,res);

      }
    })
  }
  ViewStatement(num) {
    let body = {
      internalId: this.selectedCardDetail?.internalId,
      transactionType: "Statement",
      monthYear: this.MonthYear,
      downloadType: "Data",
      email: false,
      emailId: "",
    };

    this.commonP.presentLoading();
    this.cardService
      .CardStatement(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          this.ViewStatementList = data.response.content.lst;
          this.showModal(num, "");
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  showSuccessModal(num) {
    //
    this.otp = "";
    // this.showModal("close", num);
    //  this.showModal(num, '');
    if (num == 12) {
      //
      this.GetFeildValues("CR");
      this.showModal("close", num);
      this.showModal(num, "");
    }
    if (num == 11) {
      this.GetLettersList();
      this.showModal("close", num);
      this.showModal(num, "");
    }
    if (num == 19) {
      //
      if (this.cardService.requestType == "TEMPLIMIT" && this.cardService.pendingStatus == "Pending") {
        //
        this.commonP.showErrorAlert("Sorry", "Card Temporary Limit request is pending", "OK", this._router);
        //
      }
      else {
        //
        this.showModal("close", num);
        this.showModal(num, "");
      }
    }
    else {
      this.showModal("close", num);
      this.showModal(num, "");
    }
  }

  RequestPhysicalSendOTP(val) {
    //
    this.otp = "";
    this.commonP.presentLoading();
    this.Action = val;
    // this.auth.RequestPhysicalEmailOTP(this.auth.accessToken).then((res: any) => {
    this.auth.RequestPhysicalSendOTP(this.auth.accessToken).then((res: any) => {
      if (res?.response?.code == 1) {
        //
        this.RequestPhysicalSendSMSOTP = true;
        this.showSuccessModal(14);
        //this.showSuccessModal(18);
        //
        this.commonP.hideLoading();
      } else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "OK", this._router, res);
      }
    });
  }

  DownloadStatement(date) {
    let d = date.split(" ");
    // let body = {
    //   internalId: this.selectedCardDetail?.internalId,
    //   // transactionType: "Statement",
    //   transactionType: "STATEMENT",
    //   monthYear: this.MonthYear,
    //   downloadType: "base64",
    //   email: false,
    //   emailId: ''

    // }

    d = new Date(date[0].replace(/(\d+)(\d{2})/g, "$1-$2"));
    d = this.datepipe.transform(d, "YYYYMM");

    let body = {
      internalId: this.selectedCardDetail?.internalId,
      numberOfTransactions: null,
      // transactionType: "download",
      transactionType: "STATEMENT",
      // downloadType: "pdf",

      monthYear: date ? d : this.MonthYear,
      downloadType: "base64",
      email: false,
      emailId: "",
    };

    this.commonP.presentLoading();
    this.cardService
      .CardStatement(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          // For Download file
          let decodedData = Base64.decode(data.response.content.base64);
          let blob = new Blob([decodedData], { type: "image/png" });
          saveAs(blob, data.response.content.fileName);

          // For Open in new tab

          // let fileUrl = URL.createObjectURL(blob);
          // window.open(fileUrl, '_blank');
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }
  back() {
    this.ViewGroupTransaction = false;
  }

  isValid() {
    if (this.selectedMonth) {
      return false;
    } else {
      return true;
    }
  }

  onOtpChange(e) {
    if (e.length == 6) {
      this.otp = e.toString();
    } else {
      this.otp = null;
    }
  }
  onOtpChangeverify(e) {
    if (e.length == 6) {
      this.eVerifyOTP = e.toString();
    } else {
      this.eVerifyOTP = null;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const otpInputs = document.querySelectorAll('input.otp-input');
      otpInputs.forEach((input: any) => {
        input.setAttribute('inputmode', 'numeric');
        input.setAttribute('pattern', '[0-9]*');
      });
    }, 500);
  }

  onMobileOtpChange(e) {
    if (e.length == 4) {
      this.Mverifyotp = e.toString();
    } else {
      this.Mverifyotp = null;
    }
  }
  // startTime() {
  //   var str = "1:57";

  //   var array = str.split(":");
  //   this.countdown(parseInt(array[0]), parseInt(array[1]));
  // }
  // countdown(minutes, seconds) {
  //   this.timeoutHandle;
  //   var that = this;
  //   function tick() {
  //     that.timerexpire =
  //       minutes.toString() + ":" + (seconds < 10 ? "0" : "") + String(seconds);
  //     seconds--;
  //     if (seconds >= 0) {
  //       that.timeoutHandle = setTimeout(tick, 1000);
  //     } else {
  //       if (minutes >= 1) {
  //         setTimeout(function () {
  //           that.countdown(minutes - 1, 59);
  //         }, 1000);
  //       }
  //     }

  //     if (that.timerexpire == "0:00") {
  //       that.OptTimerbtnShow = false;
  //     }
  //   }
  //   tick();
  // }

  // new timer
  startTime() {
    const expireTime = new Date().getTime() + 2 * 60 * 1000; // 2 minutes from now
    this.startCountdown(expireTime);
  }

  startCountdown(expireTimestamp: number) {
    const tick = () => {
      const now = new Date().getTime();
      const remaining = expireTimestamp - now;

      if (remaining <= 0) {
        this.timerexpire = "0:00";
        this.OptTimerbtnShow = false;
        return;
      }

      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      this.timerexpire = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      setTimeout(tick, 1000);
    };

    tick();
  }

  ResendOtp() {

    this.commonP.presentLoading();
    if (
      this.selectedCardDetail.physicalOrVirtual != "Physical" &&
      this.Action == "RequestPhysicalCard"
    ) {
      //
      // this.auth.RequestPhysicalResendSMSOTP(this.auth.accessToken).then((data: any) => {
      this.auth
        .RequestPhysicalSendOTP(this.auth.accessToken)
        .then((data: any) => {
          if (data?.response?.code == 1) {
            this.OptTimerbtnShow = true;
            this.startTime();
            //
            this.commonP.hideLoading();
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    } else if (this.selectedCardDetail.physicalOrVirtual == "Physical") {

      //
      // this.auth.ResendCRSMSOTP({}, this.auth.accessToken).then((data: any) => {
      this.auth
        .CardReplacementSendOTP({}, this.auth.accessToken)
        .then((data: any) => {
          if (data?.response?.code == 1) {
            this.OptTimerbtnShow = true;
            this.startTime();
            this.commonP.hideLoading();
            // [routerLink]="['/LetSetAccount']"
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    } else {

      //
      //  this.auth.ResendRDCSMSOTP(this.auth.accessToken).then((data: any) => {
      this.auth
        .ReplaceDigitalSendOTP({}, this.auth.accessToken)
        .then((data: any) => {
          if (data?.response?.code == 1) {
            this.OptTimerbtnShow = true;
            this.startTime();
            this.commonP.hideLoading();
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    }
  }
  async onKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      await this.CardReplacementRequest();
    }
  }

  //email otp
  async CardReplacementRequest() {
    //
    if (
      this.selectedCardDetail.physicalOrVirtual != "Physical" &&
      this.Action != "RequestPhysicalCard"
    ) {
      // if (this.selectedCardDetail.physicalOrVirtual != 'Physical') {
      //
      let data = {
        OTPCode: this.otp,
      };
      await this.commonP.presentLoading();
      this.auth
        .RDCVerifyEmailSendSMSOTP(data, this.auth.accessToken)
        .then(async (data: any) => {
          if (data?.response?.code == 1) {
            await this.commonP.hideLoading();
            this.otp = "";
            this.showModal(14, "");
            // this._router.navigate(["/CardReplacementSuccess"], { queryParams: { DigiReplaceCard: true } });
          } else {
            await this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    } else if (
      this.selectedCardDetail.physicalOrVirtual != "Physical" &&
      this.Action == "RequestPhysicalCard"
    ) {
      //
      let data = {
        OTPCode: this.otp,
      };
      //
      this.commonP.presentLoading();
      this.OptTimerbtnShow = true;
      this.startTime();
      //
      this.auth
        .RequestPhysicalSendSMSOTP(this.otp, this.auth.accessToken)
        .then((res: any) => {
          if (res?.response?.code == 1) {
            this.RequestPhysicalSendSMSOTP = true;
            this.showModal(14, "");
            this.commonP.hideLoading();
            //
          } else {
            this.RequestPhysicalSendSMSOTP = false;
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "OK", this._router, res);
          }
        });
    } else if (this.selectedCardDetail.physicalOrVirtual == "Physical") {
      //
      await this.commonP.presentLoading();
      this.auth
        .CRVerifyEmailSendSMSOTP({ OTPCode: this.otp }, this.auth.accessToken)
        .then((data: any) => {
          if (data?.response?.code == 1) {
            this.commonP.hideLoading();
            this.otp = "";
            this.showModal("close", "");
            this.showModal(14, "");
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    }
    else if (this.enableViewCard == true) {
      this.ViewCardDetail = false;
      this.showModal("close", "")
      this.showModal(14, '')
    }
  }

  async LettersRequest() {
    //
    let data = {
      internalId: this.selectedCardDetail?.internalId,
      ServiceType: this.RLServiceid,
      Product: "C", // C for card, L for loan
    };
    await this.commonP.presentLoading();
    this.cardService
      .RequestingLetters(data, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          let letterRequest = true;
          let email = this.auth?.detailuser?.emailId;
          let Refid = data?.response?.content?.card?.referenceNumber;

          await this.commonP.hideLoading();
          this._router.navigate(["/CardReplacementSuccess"], {
            queryParams: { letterRequest, email, Refid },
          });
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  cardReplacementReason(num, item) {
    //
    console.log("item", item);
    this.selectedReasonId = item.strCode;
    //
    this.showModal("close", "");
    this.showModal(num, "");
  }
  requestLetterSelectedItem(num, item) {
    console.log("requestLetterSelectedItem", item);
    this.RLServiceid = item?.srvc;
    this.showModal("close", "");
    this.CheckLettersEligibility();
  }

  cardReplacementSuccess() {
    this._router.navigateByUrl("/CardReplacementSuccess");
  }
  async GetLettersList() {
    await this.commonP.presentLoading();
    this.cardService
      .GetLettersList({ Product: "C" }, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          this.LettersList = data?.response.content.letterServicesList;
          console.log("GetLettersList", data);
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  imagePath(path) {
    if (path.search("ELT") !== -1) {
      return "MC WORLD ELITE";
    } else {
      return path;
    }
  }

  cardLimitTemporary() {
    //
    this.commonP.presentLoading();
    this.cardService.AutoTempLimit(this.selectedCardDetail.internalId, this.auth.accessToken).then((data: any) => {
      //
      if (data?.response?.code == 1) {
        this.commonP.hideLoading();
        this.AutoTempLimit = data.response.content;
        //
        console.log("this.AutoTempLimit", this.AutoTempLimit);

        this.cookieService.set("internalid", this.selectedCardDetail?.internalId, true);

        this._router.navigateByUrl("/CardLimitTemporary");
      }
      else if (data?.error.response?.code == 1) {

        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "OK", this._router, data?.error.response?.content);

      }

      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "OK", this._router, data);
      }
    });
  }

  PendingRequest() {
    this.commonP.presentLoading();
    this.cardService
      .GetPendingLimitRequest(this.auth.accessToken)
      .then((res: any) => {
        if (res?.response?.code == 1) {
          this.showModal(10, "");
          this.commonP.hideLoading();
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, res);
        }
      });
  }
  isValidOtp() {
    if (!this.otp || this.otp == undefined) {
      return true;
    } else {
      return false;
    }
  }

  isValidOtpemail() {
    if (!this.eVerifyOTP || this.eVerifyOTP == undefined) {
      return true;
    } else {
      return false;
    }
  }

  isValidMobileOtp() {
    if (!this.Mverifyotp || this.eVerifyOTP == undefined) {
      return true;
    } else {
      return false;
    }
  }

  CheckLettersEligibility() {
    //
    let body = {
      internalId: this.selectedCardDetail?.internalId,
      Type: "1", // 1 for card, 2 for loan
      ServiceType: this.RLServiceid, // map srvc key, coming from GetLetterList api
      Status: "STATUSCHECK",
    };

    this.commonP.presentLoading();
    this.cardService
      .CheckLettersEligibility(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          //
          this.commonP.hideLoading();
          this.PaymentDetail = data?.response?.content;
          this.TotalAmount =
            Number(this.PaymentDetail?.charges) +
            Number(this.PaymentDetail?.vat);

          if (
            data?.response?.content?.pendingRequestIndicator == "Y" &&
            Number(data?.response?.content?.charges) == 0
          ) {
            //  customer not eligibil
            let pendingRequest = true;
            this._router.navigate(["/CardReplacementSuccess"], {
              queryParams: { pendingRequest },
            });
          } else if (
            data?.response?.content?.pendingRequestIndicator == "N" &&
            Number(data?.response?.content?.charges) == 0
          ) {
            // Customer is Eligible No Payment Required

            this.LettersRequest();
          } else if (
            data?.response?.content?.pendingRequestIndicator == "N" &&
            Number(data?.response?.content?.charges) > 0
          ) {
            // Customer is Eligible  Payment Required
            this.PaymentRequired = true;
            this.showModal("close", "");
            this.showModal(16, "");
          }
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  InititePaymentService() {
    let body = {
      InternalId: this.selectedCardDetail?.internalId,
      VendorId: 1, // 1 for benefit gateway, 2 for benefit pay
      AccountType: "C", // C for Card, L for Loan
      Amount: this.TotalAmount,
      ServiceType: "LL",
    };

    this.commonP.presentLoading();
    this.topupservice
      .InititePaymentService(this.auth.accessToken, body)
      .then(async (data: any) => {
        if (data?.response.code == 1) {

          this.transactionRefId = data?.response?.content?.id;
          this.cookieService.set(
            "referenceId",
            this.transactionRefId,
            true
          );
          window.location.href = data?.response?.content?.url;
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  CheckStatus() {
    //
    if (this.PaymentRequired) {

      this.cookieService.set("selectedCardDetail", this.selectedCardDetail.toString(), true);

      this.cookieService.set("internalid", this.selectedCardDetail?.internalId, true);
      this.cookieService.set("ServiceType", this.RLServiceid, true);
      this.cookieService.set("Product", "C", true);

      this.InititePaymentService();
    }
    else if (this.ReplaceCard) {
      this.SendOtp();
      this.showModal("close", "");
      this.showModal(16, "");
    }
  }

  VerifyMobileOtp() {
    //
    this.commonP.presentLoading();

    if (this.selectedCardDetail.activationFlag == "N") {
      //
      let data = {
        internalCardId: this.selectedCardDetail?.internalId,
        OTPCode: this.otp,
      };
      this.commonP.presentLoading();
      this.auth
        .CardActivationVerifyOTP(data, this.auth.accessToken)
        .then(async (data: any) => {
          if (data?.response?.code == 1) {
            await this.commonP.hideLoading();
            this.GetLoanDashboad();
            this.toastr.success(
              "You have successfully activate your card.",
              " You are now available to make transaction with your card."
            );
          } else {
            await this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    } else if (
      this.selectedCardDetail.physicalOrVirtual != "Physical" &&
      this.Action == "RequestPhysicalCard" &&
      this.RequestPhysicalSendSMSOTP == true
    ) {
      //
      //this.auth.RequestPhysicalVerifySMSOTP({ OTPCode: this.otp, internalCardId: this.selectedCardDetail?.internalId, "Status": "CONVERT" }, this.auth.accessToken).then((data: any) => {
      this.auth
        .RequestPhysicalVerifyOTP(
          {
            OTPCode: this.otp,
            internalCardId: this.selectedCardDetail?.internalId,
            Status: "CONVERT",
          },
          this.auth.accessToken
        )
        .then((data: any) => {
          if (data?.response?.code == 1) {
            //
            this.commonP.hideLoading();
            this.otp = "";
            this.showModal("close", "");
            //
            this._router.navigate(["/CardReplacementSuccess"], {
              queryParams: { PhysicalReq: true },
            });

            // this.showModal(18,'');
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    } else if (
      this.selectedCardDetail.physicalOrVirtual != "Physical" &&
      this.Action != "RequestPhysicalCard"
    ) {
      //
      // this.auth.RDCVerifySMSOTP({ OTPCode: this.otp, internalCardId: this.selectedCardDetail?.internalId, "Status": "REPLACE" }, this.auth.accessToken).then((data: any) => {
      this.auth
        .ReplaceDigitalVerifyOTP(
          {
            OTPCode: this.otp,
            internalCardId: this.selectedCardDetail?.internalId,
            Status: "REPLACE",
          },
          this.auth.accessToken
        )
        .then((data: any) => {
          if (data?.response?.code == 1) {
            //
            this.commonP.hideLoading();
            this.otp = "";
            this.showModal("close", "");
            //
            this._router.navigate(["/CardReplacementSuccess"], {
              queryParams: { DigiReplaceCard: true },
            });
            // this.showModal(18, '');
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    }
    else {
      //
      let data = {
        internalCardId: this.selectedCardDetail?.internalId,
        Status: "REPLACE",
        ReplaceReason: this.selectedReasonId,
        OTPCode: this.otp,
      };
      this.commonP.presentLoading();
      this.auth
        .CardReplacementVerifyOTP(data, this.auth.accessToken)
        .then(async (data: any) => {
          if (data?.response?.code == 1) {
            await this.commonP.hideLoading();
            this._router.navigate(["/CardReplacementSuccess"], {
              queryParams: { ReplaceCard: true },
            });
          } else {
            await this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        });
    }
  }
  ChangeCardPinImtiaz() {
    // this.commonP.presentLoading();

    window.open("https://pinchange.bahraincredit.com.bh/", "_blank")
    // this.auth.ChangeCardPinImtiaz(this.auth.accessToken).then((data: any) => {

    //   if (data?.response?.code == 1) {

    //     console.log(data, "ChangeCardPinImtiaz");
    //     let key = this.cookieService.generateKey();
    //     this.cookieService.set(
    //       "internalCardId",
    //       this.selectedCardDetail?.internalId,
    //       false,
    //       key
    //     );

    //     this._router.navigateByUrl("/ChangePinVerify");
    //     this.commonP.hideLoading();
    //   } else {
    //     this.commonP.hideLoading();
    //     this.commonP.ParseErrorAlert("Sorry", "Ok", this._router, data);
    //   }
    // });
  }

  cardLimitPermanent() {
    this._router.navigateByUrl("/CardLimitPermanent");
  }
  RewardsLoyaltyPoints() {
    this._router.navigateByUrl("/LoyaltyPoints");
  }

  // this._router.navigateByUrl("/CardReplacementSuccess");

  Verifytoken() {

    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {


      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
            console.log("VerifyToken", data.response.content);
            this.MobNum = data.response.content.mobileNumber;
            this.Eemail = data.response.content.emailId;
            console.log(this.Eemail, this.MobNum, "hereusu");

          } else {
            //
            await this.commonP.hideLoading();
            // this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          //
          await this.commonP.hideLoading();
          // this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        //
        await this.commonP.hideLoading();
        // this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  async DashboardApi() {


    await this.account.GetLoanDashboard(this.auth.accessToken).then(async (data: any) => {


      if (data?.response?.code == 1) {
        this.reward.GetRewardsSummary(this.auth.accessToken).then((data: any) => {

          // this.sinnadExistingCheck=data?.response?.content?.cardDetails[0]?.source
          // this.sinnadExistingCheck = data.response.content.cardDetails[0]?.source;
          // if (data?.response?.content?.cardDetails && Array.isArray(data.response.content.cardDetails) && data.response.content.cardDetails.length > 0) {
          //   this.sinnadExistingCheck = data.response.content.cardDetails[0].source;
          // } else {
          //   this.sinnadExistingCheck = null; // Ya koi default value
          // }

          console.log(this.sinnadExistingCheck, "sinadcheck");
          // outstanding line
          this.availableBalance = data?.response?.content?.cardDetails?.[0]?.availableCreditLimit;
          this.outstandingBalance = data?.response?.content?.cardDetails?.[0]?.outstandingAmount;

          const available = Number(this.availableBalance) || 0;
          const outstanding = Math.abs(Number(this.outstandingBalance)) || 0;

          // total limit (max value)
          const totalLimit = available + outstanding;

          // percentage calculate karo
          this.usedPercentage = totalLimit ? (outstanding / totalLimit) * 100 : 0;

          // agar value 100 se zyada ho jaye to clamp kar do
          if (this.usedPercentage > 100) {
            this.usedPercentage = 100;
          }

          // outstanding line
          if (data?.response?.code == 1) {
            this.commonP.hideLoading();
            this.LoyaltyCards = data.response.content;
            console.log(" this.LoyaltyCards", this.LoyaltyCards);
            let points = [];
            data?.response?.content.forEach((x) => {
              points.push(Number(x.rewardsBalance));
            });
            this.loyalityPoints = points.reduce(
              (accumulator, currentvalue) => {
                return accumulator + currentvalue;
              },
              0
            );
            console.log('this.loyalityPoints', this.loyalityPoints)
          } else {
            this.commonP.hideLoading();
            this.commonP.ParseErrorAlert(
              "",
              "",
              this._router,
              data
            );
          }
        });
        let CardDetails = data.response.content.cardDetails;
        this.cardDetail = CardDetails.filter(
          (x) => x.displayFlag == "Y"
        );
        //
        console.log("CardDetails2", CardDetails);
        this.sinnadStatus = data.response.content.cardDetails[0]
        console.log("sinadStatus2", this.sinnadStatus);
        this.sinnadExistingCheck = data?.response?.content?.cardDetails[0]?.source
        console.log("sinnadExistingCheck", this.sinnadExistingCheck);
        // outstanding line
        this.availableBalance = data?.response?.content?.cardDetails?.[0]?.availableCreditLimit;
        this.outstandingBalance = data?.response?.content?.cardDetails?.[0]?.outstandingAmount;

        const available = Number(this.availableBalance) || 0;
        const outstanding = Math.abs(Number(this.outstandingBalance)) || 0;

        // total limit (max value)
        const totalLimit = available + outstanding;

        // percentage calculate karo
        this.usedPercentage = totalLimit ? (outstanding / totalLimit) * 100 : 0;

        // agar value 100 se zyada ho jaye to clamp kar do
        if (this.usedPercentage > 100) {
          this.usedPercentage = 100;
        }

        // outstanding line
        // internalid for sinnad pin change
        this.cardInternalID = data?.response?.content?.cardDetails[0]?.internalId;
        console.log("cardInternalID1", this.cardInternalID);

        this.cookieService.set("InternallID", this.cardInternalID, true);

        //  product codes 
        this.cardProductCode = data?.response?.content?.cardDetails[0]?.productCode;
        console.log("cardProductCode1", this.cardProductCode);


        if (this.internalId != undefined && this.internalId != "" && this.Home == 'Home') {

          this.cardDetail.filter((x, index) => {
            if (x.internalId == this.internalId) {

              this.selectedCardDetail = x

              this.cardDetail.splice(index, 1);

              this.cardDetail.unshift(x);
              this.selectCard(0);

            }
          })

        }
        else {
          this.selectedCardDetail = this.cardDetail[0];
          this.loadedCardIndex = 0;

          let body = {
            internalId: this.selectedCardDetail?.internalId,
            numberOfTransactions: "10",
            transactionType: "Last",
          };

          if (this.selectedCardDetail?.freezed == "N" && this.selectedCardDetail?.stopped == "N") {
            await this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
              if (data?.response?.code == 1) {
                //
                let CardTransactionHistory = data.response.content.cardTransactions;
                console.log("ngOninitUngroup", CardTransactionHistory)
                this.UnGroupCardTransactionHistory = CardTransactionHistory;

                //  this.ViewGroupTransaction = this.UnGroupCardTransactionHistory.length > 0 ? true: false;

                this.selectedCardIndex = 0;
                this.commonP.hideLoading();

                // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                // this.selectedCardDetail=this.cardDetail[0];
              } else {
                //

                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert(
                  "",
                  "",
                  this._router,
                  data
                );
              }
            });
            this.showTransaction = true;
          }
          if (this.selectedCardDetail?.freezed == "Y") {
            //

            await this.cardService.GetTransactionUngroup(body, this.auth.accessToken).then((data: any) => {
              if (data?.response?.code == 1) {
                //
                let CardTransactionHistory =
                  data.response.content.cardTransactions;
                this.UnGroupCardTransactionHistory = CardTransactionHistory;

                // this.ViewGroupTransaction = this.UnGroupCardTransactionHistory.length > 0 ? true: false;

                this.selectedCardIndex = null;
                this.commonP.hideLoading();

                // this.cardDetail=CardDetails.filter(x=>x.displayFlag=='Y');
                // this.selectedCardDetail=this.cardDetail[0];
              } else {
                //

                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert(
                  "",
                  "",
                  this._router,
                  data
                );
              }
            });
            this.showTransaction = true;
          }
          if (this.selectedCardDetail?.stopped == "Y") {
            //

            this.commonP.hideLoading();
            this.selectedCardIndex = 0;
            this.showTransaction = false;
          }

        }

        for (let item of this.cardDetail) {
          //
          // let cal=(Number(item.availableCreditLimit - (- item.outstandingAmount))/100);
          let cal = item.outstandingAmount / 100;
          console.log("Cal", cal);
          //
          if (cal < 0) {
            this.totalslidervalues.push("0");
          } else {
            this.totalslidervalues.push(cal.toString());
          }
        }
        if (this.selectedCardDetail?.stopped == "Y") {

          this.selectedCardIndex = 0;
          this.disabledServices = true;
        } else {
          this.selectedCardIndex = null;
          this.showTransaction = false;
          this.disabledServices = false;
        }
        // this.cardDetail=[];

        // cardactivation manual
        // if (
        //   this.selectedCardDetail &&
        //   this.selectedCardDetail?.activationFlag == "N"
        // ) {
        //
        //   this.OptTimerbtnShow = true;
        //   this.startTime();
        //   this.auth.CardActivationSendOTP(this.auth.accessToken).then((res: any) => {
        //
        //     if (res?.response?.code == 1) {
        //       this.otp = "";
        //       // this.showModal("close", '');
        //       this.showModal(14, "");
        //       this.commonP.hideLoading();

        //
        //     }
        //     else {
        //       this.commonP.hideLoading();
        //       this.commonP.ParseErrorAlert(
        //         "Sorry",
        //         "Ok",
        //         this._router,
        //         res
        //       );
        //     }
        //   });
        // }


      }
      else {
        //
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }

  sinadUserpin() {

    // this._router.navigateByUrl("/ChangeCardPinSinnad"); 
    // this._router.navigateByUrl("/ChangeCardPinSinnad"); 
    console.log(this.sinnadExistingCheck, "gps");
    console.log(this.sinnadExistingCheck, "nongps");
    // prod par move sinnad k lia isko uncommnet karna hai
    if (this.sinnadExistingCheck === 'GPS') {
      this.showModal("close", "");
      this.showModal(17, "");
    } else if (this.sinnadExistingCheck === 'SINNAD') {
      this._router.navigateByUrl("/ChangeCardPinSinnad");
    }
    // this.showModal("close", "");
    // this.showModal(17, "");
  }


  hideShowCard() {

    this.eVerifyOTP = ""
    this.showCardDetails = !this.showCardDetails; // Toggle the state

    if (this.showCardDetails) {
      // If the state is "show," open the modal
      this.sendEmailOtp();
      this.OptTimerbtnShow = true;
      this.isLoadingComplete = false;
      this.startTime();

    } else {
      // If the state is "hide," mask the card number (logic here depends on your app)
      this.maskCardNumber();
      this.NumberView = ""
      this.isLoadingComplete = false
      this.NumberView = ""
    }
  }

  async sendEmailOtp() {

    let body = {
    }
    this.commonP.presentLoading();
    this.auth.SendOTPByEmailandMobile(body, this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {
        console.log('sendEmail&MobileOtpSucess', data);
        this.maskedEmail = data?.response?.content?.email
        this.mobilNomasked = data?.response?.content?.mobile
        // empty email otp
        this.eVerifyOTP = ""; // Reset variable
        if (this.otpInput) {
          this.otpInput.setValue(''); // Use the NgOtpInputComponent method to reset
        }

        // Reset mobile OTP
        this.Mverifyotp = "";
        if (this.otpInputMobile) {
          this.otpInputMobile.setValue('');
        }

        //  
        this.commonP.hideLoading();
        this.showModal(23, "");

      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this._router, data);

      }
    });
  }

  async resendEmailOTP() {
    this.OptTimerbtnShow = true;
    this.startTime();
    let body = {
    }
    // this.commonP.presentLoading();
    this.auth.ResendOTPByEmailnMobile(body, this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {
        console.log('sendEmailOtpSucess', data);
        this.maskedEmail = data?.response?.content?.email
        // this.commonP.hideLoading();
        // this.showModal(23, "");

      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this._router, data);

      }
    });
  }

  async VerifyEmailOTP() {
    let body = {
      OTPCode: this.eVerifyOTP,
      FirebaseToken: null
    }
    this.commonP.presentLoading();
    this.auth.VerifyOTPByEmailnMobile(body, this.auth.accessToken).then(async (data: any) => {

      if (data?.response?.code == 1) {
        console.log('VerifyOTPByEmailnMobile', data);
        this.maskMobileNO = data?.response?.content?.mobile
        await this.generatekey();
        //  this.commonP.hideLoading();
        //  this.showModal(24, "");

      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this._router, data);

      }
    });
  }

  async generatekey() {
    let body = {

    }

    this.setting.GenerateKeyPair(body, this.auth.accessToken).then(async (data: any) => {

      if (data?.response?.code == 1) {
        console.log('GenerateKeyPairSucess', data);
        this.publicKEY = data?.response?.content?.publicPEM
        this.privateKEY = data?.response?.content?.privatePEM
        // this.commonP.hideLoading();
        // this.showModal(24, "");
        // isky bad ki kahani
        await this.cardincreptedDetails();

      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this._router, data);

      }
    });
  }
  ResendOTP() {


    this.OptTimerbtnShow = true;
    this.startTime();
    let body = {
      OTPCode: this.Mverifyotp,
    }

    this.auth.ResendOTPBySMS(body, this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {
        console.log('ResendOTPSucess', data);

        this.commonP.hideLoading();


      } else {
        this.commonP.hideLoading();

        this.commonP.ParseErrorAlert('', '', this._router, data);

      }
    });
  }

  // verifyMobile() {


  //   let body = {
  //     OTPCode: this.Mverifyotp,
  //   }
  //   this.commonP.presentLoading();
  //   this.auth.VerifyOTPBySMS(body, this.auth.accessToken).then((data: any) => {

  //     if (data?.response?.code == 1) {
  //       console.log('verifyMobileSucess', data);
  //       this.cardincreptedDetails();

  //     } else {
  //       this.commonP.hideLoading();

  //       this.commonP.ParseErrorAlert('', '', this._router, data);

  //     }
  //   });
  // }


  async cardincreptedDetails() {
    //
    let body = {
      InternalId: this.cardInternalID,
      publicKey: this.publicKEY
    };

    try {
      const data: any = await this.cardService.CardDataV1(body, this.auth.accessToken);
      //

      if (data?.response?.code == 1) {
        console.log('CardDataV1Sucess', data);
        this.encdata = data?.response?.content?.data
        this.encdata2 = data?.response?.content?.data1
        this.commonP.hideLoading();
        const decryptedData = await this.decryptRSA(this.encdata2, this.privateKEY);

        console.log('Decrypted Data:', decryptedData);

        const key = await this.importKey(decryptedData);

        const iv = new Uint8Array(16);
        const decryptedDataBytes = new TextEncoder().encode(decryptedData);
        iv.set(decryptedDataBytes.slice(0, 16));

        const encryptedData = this.encdata;

        const decryptedText = await this.decryptWithAES(encryptedData, key, iv);
        console.log('Second Decrypted Data:', decryptedText);
        const first7Digits = decryptedText.slice(0, 8);

        // 8 digits
        const last8Digits = decryptedText.slice(-8);
        this.NumberView = first7Digits + last8Digits;
        console.log("card123", this.NumberView);

        //c no
        let cvv = "";
        const trimmedText = decryptedText.slice(8, -8);
        const reversedText = trimmedText.split("").reverse().join(""); // "2529201"
        cvv += reversedText[0];
        cvv += reversedText[3];
        cvv += reversedText[6];
        this.cNumber = cvv;
        console.log("cno", this.cNumber);


        // date of e


        const extractExpiryDate = (text: string) => {
          if (text.length !== 23) return "Invalid data length";

          const month = text.slice(9, 11); // 10th & 11th character
          const year = text.slice(12, 14); // 13th & 14th character

          return `${month}/${year}`;
        };

        const expiryDate = extractExpiryDate(decryptedText);
        console.log("Expiry Date", expiryDate);
        this.epDate = extractExpiryDate(decryptedText);

        console.log("Date", this.epDate);
        // 
        this.isLoadingComplete = true;
        this.commonP.hideLoading();

      } else {
        this.commonP.hideLoading();
        //
        this.commonP.ParseErrorAlert('', '', this._router, data);
      }
    } catch (error) {
      console.error('Error:', error);
      this.commonP.hideLoading();
    }
  }
  //first decription
  async decryptRSA(encryptedData: string, privateKeyPEM: string): Promise<string> {
    try {
      privateKeyPEM = privateKeyPEM
        .replace(/-----BEGIN PRIVATE KEY-----/, "")
        .replace(/-----END PRIVATE KEY-----/, "")
        .replace(/\n/g, "")
        .trim();

      // Import the private key with SHA-1
      const privateKey = await window.crypto.subtle.importKey(
        'pkcs8',
        this.base64ToArrayBuffer(privateKeyPEM),
        {
          name: 'RSA-OAEP',
          hash: { name: 'SHA-1' },
        },
        false,
        ['decrypt']
      );

      const encryptedArrayBuffer = this.base64ToArrayBuffer(encryptedData);

      const decryptedArrayBuffer = await window.crypto.subtle.decrypt(
        {
          name: 'RSA-OAEP',
        },
        privateKey,
        encryptedArrayBuffer
      );

      return new TextDecoder().decode(decryptedArrayBuffer);
    } catch (error) {
      console.error('Decryption failed:', error);
      throw error;
    }
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    try {
      base64 = base64.replace(/[^A-Za-z0-9+/=]/g, "").trim();

      const binaryString = window.atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    } catch (error) {
      console.error("Invalid Base64 string:", error);
      throw error;
    }
  }

  // 2nd time decription

  async importKey(decryptedData) {
    const enc = new TextEncoder();
    const keyData = enc.encode(decryptedData);
    return await crypto.subtle.importKey(
      'raw',
      keyData,
      { name: 'AES-CBC' },
      false,
      ['decrypt']
    );
  }

  async decryptWithAES(encryptedData, key, iv) {
    const enc = new TextEncoder();
    const encryptedBuffer = Uint8Array.from(atob(encryptedData), c => c.charCodeAt(0)); // Decode base64

    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: 'AES-CBC',
        iv: iv
      },
      key,
      encryptedBuffer
    );

    const dec = new TextDecoder();
    return dec.decode(decryptedBuffer);
  }





  async VerifyEmailOTPRegister() {

    //   let body = {
    // UniqueId: this.commonP.Guid(),
    // IdNumber: this.selectedCardDetail.cRorCPR,
    // EmailId: this.Eemail,
    // MobileNumber: this.MobNum,
    // OTPCode: this.otp,
    // FirebaseToken: null
    //   };

    //   await this.commonP.presentLoading();
    //   this.auth.VerifyEmailOTPRegister(this.auth.accessToken, body)
    //     .then(async (data: any) => {
    //       if (data?.response?.code == 1) {
    //         await this.commonP.hideLoading();
    //         //this.showModal(num);
    //         this._router.navigateByUrl("/MobileOtpVerify");

    //       } else {
    //         await this.commonP.hideLoading();
    //         this.commonP.ParseErrorAlert("", "", this._router, data);
    //       }
    //     });
  }


  getDate(dateTime: string): string {
    if (!dateTime) return '';
    return dateTime.split(' ')[0]; // Extracts the date part
  }

  getTime(dateTime: string): string {
    if (!dateTime) return '';
    return dateTime.split(' ')[1]; // Extracts the time part
  }

  userSwitch() {

    let body = {
      ServiceType: "Conventional"
    }
    this.commonP.presentLoading();
    this.account.UpdateServiceMode(body, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("UpdateServiceModesucess", data);
          await this.getService()
          await this.commonP.hideLoading();

        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  async getService() {

    // await this.CommonService.presentLoading();
    this.account.GetServiceType({}, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("GetServiceTypesucess", data);

          this.serviceType = data?.response?.content?.serviceType
          this.cookieService.set(
            "sTyp",
            this.serviceType,
            true,
          );
          await this.commonP.hideLoading();

          // this.router.navigateByUrl("/Dashboard");
          // dashboard ko reload karwana without losing session
          // this._router.routeReuseStrategy.shouldReuseRoute = () => false;
          // this._router.onSameUrlNavigation = 'reload';
          // this._router.navigate(['/DashboardCreditCards']);
          window.location.reload();
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

} 
